import { api } from '../api/client';
import { API_URL } from '../utils';

/** Items per page the palette asks for: a jump-off list, not a results page (the server's default is 20, its ceiling 50). */
export const PALETTE_ITEM_LIMIT = 6;

/**
 * `GET /api/search?types=items` (keepr-api docs/SCHEMA.md, "Global search"):
 * the items the caller can read whose words match `q`, ranked by relevance
 * (KPR-490), each with its title as the caller may see it (`displayValue`), a
 * `score` and a `snippet`. Only the items bucket is asked for, so a term the
 * server cannot search is a 400 carrying its own sentence, never a 200 with
 * `itemsRefused`. `cursor` is a previous answer's `itemsNextCursor`.
 */
export async function searchItems(q, { limit = PALETTE_ITEM_LIMIT, cursor = null } = {}, config = {}) {
	const params = { q, types: 'items', limit };
	if (cursor) params.cursor = cursor;
	const { data } = await api.get(`${API_URL}/search`, { ...config, params });
	return data;
}
